import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { PageHero, Container } from "../components/Section";
import { useAuth } from "../lib/auth";
import { formatApiError } from "../lib/api";

export default function Register() {
  const [form, setForm] = useState({ name: "", email: "", password: "", phone: "", ministry: "" });
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const nav = useNavigate();

  const u = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success("Welcome to the family!");
      nav("/members");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally { setLoading(false); }
  };

  return (
    <div data-testid="register-page">
      <PageHero
        overline="Create Account"
        title={<>Join the <em className="text-gold-light italic font-light">family</em>.</>}
        kicker="A member account unlocks resources, ministry tools, and media requests."
      />
      <Container className="pb-32">
        <form onSubmit={submit} className="glass p-10 max-w-md space-y-6" data-testid="register-form">
          <Field label="Full Name"><input data-testid="reg-name" required value={form.name} onChange={u("name")} className={cls} /></Field>
          <Field label="Email"><input data-testid="reg-email" type="email" required value={form.email} onChange={u("email")} className={cls} /></Field>
          <Field label="Password (min 6 chars)"><input data-testid="reg-password" type="password" required minLength={6} value={form.password} onChange={u("password")} className={cls} /></Field>
          <Field label="Phone (optional)"><input data-testid="reg-phone" value={form.phone} onChange={u("phone")} className={cls} /></Field>
          <Field label="Ministry (optional)"><input data-testid="reg-ministry" value={form.ministry} onChange={u("ministry")} className={cls} placeholder="e.g. Music Ministry" /></Field>
          <button type="submit" disabled={loading} className="btn-wine w-full py-3.5 rounded-full text-sm uppercase tracking-widest font-semibold disabled:opacity-50" data-testid="reg-submit">
            {loading ? "Creating…" : "Create Account"}
          </button>
          <div className="text-sm text-white/60 text-center">
            Already a member? <Link to="/login" className="text-gold hover:text-gold-light underline">Sign in</Link>
          </div>
        </form>
      </Container>
    </div>
  );
}

const cls = "w-full bg-transparent border-0 border-b border-white/15 px-0 py-3 focus:outline-none focus:border-gold";
function Field({ label, children }) {
  return (
    <label className="block">
      <div className="text-xs uppercase tracking-widest text-white/55 mb-2 font-semibold">{label}</div>
      {children}
    </label>
  );
}
